import { render, staticRenderFns } from "./AccountLogout.vue?vue&type=template&id=27497e9f&scoped=true"
import script from "./AccountLogout.vue?vue&type=script&lang=js"
export * from "./AccountLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27497e9f",
  null
  
)

export default component.exports